import React from "react";
import YouTubePlayer from "youtube-player";

class YouTubeVideo extends React.Component {
  componentDidMount() {
    const { videoId, autoplay } = this.props;
    this.player = YouTubePlayer("player", {
      videoId,
      playerVars: { autoplay },
    });
  }

  componentDidUpdate({ start, videoId, autoplay }) {
    if (videoId !== this.props.videoId) {
      this.player.loadVideoById(videoId);
      this.player.mute();
    }
    if (start || start === 0) {
      this.player.unMute();
      this.player.seekTo(start);
      this.player.playVideo();
    }
    if (autoplay !== this.props.autoplay && autoplay) {
      this.player.playVideo();
    }
  }

  componentDidUpdate() {
    const { autoplay } = this.props;
    if (autoplay) {
      this.player.playVideo();
    }
  }

  render() {
    return (
      <div className="embedded-video">
        <div id="player" />
      </div>
    );
  }
}

export default YouTubeVideo;